import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import PublicOrder from "@/pages/PublicOrder";

/**
 * Route handler for /qr/:token.
 * - Internal authenticated users → resolve token and redirect to /orders/:id
 * - Unauthenticated visitors (customers) → show the public read-only portal
 */
export default function QrRedirect() {
  const { token } = useParams();
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [resolving, setResolving] = useState(false);

  useEffect(() => {
    if (loading) return;
    if (!user) return; // Public portal will render below
    setResolving(true);
    api
      .get(`/orders/by-qr/${token}`)
      .then((r) => navigate(`/orders/${r.data.id}`, { replace: true }))
      .catch((e) => {
        toast.error(formatApiError(e));
        navigate("/orders", { replace: true });
      })
      .finally(() => setResolving(false));
  }, [token, user, loading, navigate]);

  if (loading || (user && resolving)) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500 font-mono bg-slate-50">
        Resolviendo QR…
      </div>
    );
  }
  if (user) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500 font-mono bg-slate-50">
        Abriendo orden…
      </div>
    );
  }
  return <PublicOrder />;
}
